/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { UploadTabNames } from "../props";
import DocumentView from "../DocumentView";
import api from "../../../../../api";
import { useDataLoader } from "react-remote-data-hooks";
import VersionList from "../VersionList";
import SignedTimesheet from "../SignedTimesheet";
import SignedVersionList from "../SignedVersionList";

const UploadDocument: React.FunctionComponent<{
  onClose?: () => void;
  reload?: (id?: string) => void;
  proposalDocument?: any;
  isSigned?: boolean;
  title?: string;
  versions?: any[];
  isLandlordCopy?: boolean;
  onEdit?: () => void;
}> = (props) => {
  const [tabName, setTabName] = React.useState<UploadTabNames>(
    props.isSigned
      ? UploadTabNames.SignedTimesheet
      : UploadTabNames.TimesheetInProgess
  );
  const setElementActive = (tabValue: UploadTabNames) => {
    setTabName(tabValue);
  };

  const currentDocument = !props.isLandlordCopy
    ? props.proposalDocument?.document
    : props.proposalDocument?.seperateDocumentForLandlord;

  const [signedDocument, setSignedDocument] = useState(
    props.isLandlordCopy
      ? props.proposalDocument?.signedLandlordDocument
      : props.proposalDocument?.signedClientDocument
  );

  const {
    data: signedDocuments,
    reload: signedDocumentsReload,
    loading: signedDocumentsLoading,
  } = useDataLoader<any>(
    (docId: string) =>
      docId
        ? api.proposalDocument.getSignedDocumentsList(
            docId!,
            props.isLandlordCopy
              ? "Signed Landlord Document"
              : "Signed Client Document"
          )
        : undefined,
    [props.isLandlordCopy ? props.proposalDocument?.seperateDocumentForLandlord?._id : props.proposalDocument?.document?._id ]
  );

  React.useEffect(() => {
    if (!signedDocumentsLoading) {
      setSignedDocument(
        props.isLandlordCopy
          ? props.proposalDocument?.signedLandlordDocument
          : props.proposalDocument?.signedClientDocument
      );
    }
  }, [props.proposalDocument]);

  return (
    <>
      <div className="container-fluid px-0 h-100">
        <div className="h-100 mt-2 px-4 row">
          <div
            className={`${
              tabName === UploadTabNames.TimesheetVersion
                ? "col-12 bg-white"
                : "col-12 bg-white"
            }`}
          >
            <ul
              className="d-flex list-unstyled tab-underline font-sm font-weight-semibold border-bottom text-nowrap overflow-auto"
              id="activity-tab"
              role="tablist"
            >
              {!props.isSigned && (
                <>
                  <li className="nav-item pr-4 pl-4" role="presentation">
                    <a
                      className={`cursor-pointer nav-link position-relative px-0 py-2 text-gray-600 ${
                        tabName === UploadTabNames.TimesheetInProgess
                          ? "active"
                          : ""
                      }`}
                      onClick={(e) => {
                        setElementActive(UploadTabNames.TimesheetInProgess);
                      }}
                    >
                      <span className="py-1 d-inline-flex">
                        {props.title} In Progess
                      </span>
                    </a>
                  </li>
                  <li className="nav-item pr-4 pl-4" role="presentation">
                    <a
                      className={`cursor-pointer nav-link position-relative px-0 py-2 text-gray-600 ${
                        tabName === UploadTabNames.TimesheetVersion
                          ? "active"
                          : ""
                      }`}
                      onClick={(e) => {
                        setElementActive(UploadTabNames.TimesheetVersion);
                      }}
                    >
                      <span className="py-1 d-inline-flex">Version</span>
                    </a>
                  </li>
                </>
              )}
              {(!!currentDocument?.clientApproval ||
                !!currentDocument?.landlordApproval) && (
                <>
                  <li className="nav-item pr-4 pl-4" role="presentation">
                    <a
                      className={`cursor-pointer nav-link position-relative px-0 py-2 text-gray-600 ${
                        tabName === UploadTabNames.SignedTimesheet
                          ? "active"
                          : ""
                      }`}
                      onClick={(e) => {
                        setElementActive(UploadTabNames.SignedTimesheet);
                      }}
                    >
                      <span className="py-1 d-inline-flex">
                        Signed {props.title}
                      </span>
                    </a>
                  </li>
                  <li className="nav-item pr-4 pl-4" role="presentation">
                    <a
                      className={`cursor-pointer nav-link position-relative px-0 py-2 text-gray-600 ${
                        tabName === UploadTabNames.SignedTimesheetVersion
                          ? "active"
                          : ""
                      }`}
                      onClick={(e) => {
                        // if (!!allFiles?.length) {
                        setElementActive(UploadTabNames.SignedTimesheetVersion);

                        // }
                      }}
                    >
                      <span className="py-1 d-inline-flex">
                        Signed {props.title} Version
                      </span>
                    </a>
                  </li>
                </>
              )}
            </ul>
            {tabName === UploadTabNames.TimesheetInProgess && (
              <>
                <DocumentView
                  currentFile={props.proposalDocument}
                  reload={() => {
                    props.reload?.();
                  }}
                  onEdit={props.onEdit}
                  versions={props.versions}
                  changeDocument={(id: string) => {
                    props.reload?.(id);
                  }}
                  title={props.title}
                  noBoarder
                  isLandlordCopy={props.isLandlordCopy}
                ></DocumentView>
              </>
            )}
            {tabName === UploadTabNames.TimesheetVersion && (
              <>
                <VersionList
                  versions={props.versions}
                  onView={(docId: string) => {
                    props.reload?.(docId);
                    setElementActive(UploadTabNames.TimesheetInProgess);
                  }}
                  isLandlordCopy={props.isLandlordCopy}
                  hideVendor={!props.isLandlordCopy}
                  hideClient={props.isLandlordCopy}
                ></VersionList>
              </>
            )}
            {tabName === UploadTabNames.SignedTimesheet && (
              <>
                <SignedTimesheet
                  versions={
                    !props.isLandlordCopy
                      ? props.versions?.filter(
                          (x) =>
                            x.document?.internalApproval?.status ===
                              "Approved" &&
                            (!!x.document?.clientApproval ||
                              !!x.document?.landlordApproval)
                        )
                      : props.versions?.filter(
                          (x) =>
                            x.seperateDocumentForLandlord?.internalApproval
                              ?.status === "Approved" &&
                            (!!x.seperateDocumentForLandlord?.clientApproval ||
                              !!x.seperateDocumentForLandlord?.landlordApproval)
                        )
                  }
                  proposalId={
                    props.proposalDocument?.proposedPropertyDetails[0]?.proposalId
                  }
                  documentSettingsId={
                    props.proposalDocument?.documentSettingsId
                  }
                  documentId={props.proposalDocument?._id}
                  onSuccess={(doc: any) => {
                    props.reload?.(props.proposalDocument?._id);
                    setSignedDocument(doc);
                    signedDocumentsReload(
                      props.isLandlordCopy ? props.proposalDocument?.seperateDocumentForLandlord?._id : props.proposalDocument?.document?._id
                    );
                  }}
                  title={props.title}
                  noBoarder
                  hideLandlordCopy={!props.isLandlordCopy}
                  hideClientCopy={props.isLandlordCopy}
                  signedDocument={signedDocument}
                  proposedPropertyId={
                    props?.proposalDocument?.proposedPropertyDetails[0]
                      ?.propertyDetails?.propertyId
                  }
                ></SignedTimesheet>
              </>
            )}
            {tabName === UploadTabNames.SignedTimesheetVersion && (
              <>
                <SignedVersionList
                  versions={signedDocuments}
                  onView={(doc: any) => {
                    setSignedDocument(doc);
                    setElementActive(UploadTabNames.SignedTimesheet);
                  }}
                  title={props.title}
                  hideVendor={!props.isLandlordCopy}
                  hideClient={props.isLandlordCopy}
                ></SignedVersionList>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default UploadDocument;
